import { render, staticRenderFns } from "./PSkeleton.vue?vue&type=template&id=571a5e54&"
import script from "./PSkeleton.vue?vue&type=script&lang=js&"
export * from "./PSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports